import { ModelBase } from '../../shared/base/model-base';

export class LessonAttachment extends ModelBase {
  name: string;
  downloadURL: string;
  owner: string;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/shared/lesson-attachment.ts